import React from 'react';
import styles from './O_CapsuleReactionsHeader.module.css';
import A_CircleButton from '@/components/A_Atoms/A_CircleButton/A_CircleButton';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import { O_CapsuleReactionsHeaderProps } from './types';

export default function O_CapsuleReactionsHeader({
  onBack,
  onExpand,
  isExpanded,
  showExpandButton = true,
  onOpenPostMenu,
  showPostMenuButton = false,
}: O_CapsuleReactionsHeaderProps) {
  return (
    <header className={styles.wrapper}>
      <A_CircleButton
        icon={
          <Q_Icon.ArrowLeftIcon
            width={24}
            height={24}
            stroke='currentColor'
            fill='none'
          />
        }
        onClick={onBack}
        variant='secondary'
      />
      <div className={styles.center_wrapper} />
      {showPostMenuButton ? (
        <A_CircleButton
          icon={<Q_Icon.InfoIcon width={3} height={14} fill='none' />}
          onClick={() => onOpenPostMenu?.()}
          variant='secondary'
        />
      ) : showExpandButton ? (
        <A_CircleButton
          icon={
            isExpanded ? (
              <Q_Icon.ReduceIcon width={24} height={24} fill='none' />
            ) : (
              <Q_Icon.ExpandIcon width={24} height={24} fill='none' />
            )
          }
          onClick={onExpand}
          variant='secondary'
        />
      ) : null}
    </header>
  );
}
